import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiToggleButtonGroup = ({ palette }: Pick<Tokens, 'palette'>) =>
  ({
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          padding: spacing(1.25),
          borderRadius: spacing(1),
          gap: 0,
          backgroundColor: palette.background.default,

          '& .MuiToggleButton-root': {
            border: 0,

            '&:not(:first-of-type)': {
              borderLeft: 0,
            },
          },
        },
        groupedHorizontal: {
          marginLeft: 0,
        },
      },
    },
  }) satisfies ComponentCreation
